import { action, observable } from 'mobx';
import modernBrandingService from './modernBrandingService';

class ModernBrandingStore {
    @observable modernBranding = null;

    async loadModernBranding(diId) {
        const modernBranding = await modernBrandingService.getModernBranding(
            diId,
        );
        this.setModernBranding(modernBranding);
    }

    @action
    setModernBranding(modernBranding) {
        this.modernBranding = modernBranding;
    }
}

export default new ModernBrandingStore();
